/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface GeneratePayMercPagoDto { 
    qtDeliveryCharge?: number;
    token: string;
    installments: number;
    paymentMethodId: string;
    payerDocType: string;
    payerDocNumber: string;
}